
import React, { useContext } from 'react'
import { useDispatch } from 'react-redux';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import { updateFilters } from 'actions/planner-filters';
import { AdvFilterV2Context, FilterIcon } from '../filterContext';


const AutocompleteFilter = ({ title, payloadKey, options, value }) => {
  const dispatch = useDispatch();
  const v2 = useContext(AdvFilterV2Context);
  const hasValue = (value || []).length > 0;
  // const selectedValues = useMemo(() => value.length > 0 ? value.split(',') : [], [value])
  // console.log("in autocomplete", title, selectedValues, value)

  return (
    <Grid container spacing={2} alignItems='center' justifyContent='space-evenly' sx={{ mb: 2 }}>
          <Grid item xs={3}>
            <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
              {v2 && <FilterIcon title={title} />}
              {title}
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Autocomplete
              multiple
              size="small"
              options={options}
              value={value || []}
              // getOptionLabel={(option) => option.label}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={v2 && !hasValue ? `Select ${title.toLowerCase()}` : undefined}
                />
              )}
              onChange={(_, newValue) => {
                dispatch(updateFilters(payloadKey, newValue.length > 0 ? newValue : null))
              }}
              limitTags={1}
              fullWidth
            />
          </Grid>
        </Grid>
  )
}

export default AutocompleteFilter